// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Icon/Icon.less
// module id = 213
// module chunks = 2